//widgets/_new/cards/vendors/distribution/accounts/TotalBalanceCard.tsx
import React, { FC, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMoneyCheckDollar } from '@fortawesome/free-solid-svg-icons'

const fmt=(n:number)=>n>=1e6?(n/1e6).toFixed(1)+'M':n>=1e3?(n/1e3).toFixed(1)+'K':Math.round(n)+''
interface Props{
  balance:number
  ytd:number
}
const TotalBalanceCard:FC<Props>=({balance,ytd})=>{
 const[hover,setHover]=useState(false)
 return(
  <div className='card h-100 min-h-100' style={{background:'linear-gradient(45deg,#27A47C,#6FE594 120%)', minHeight: '13rem'}}
       onMouseEnter={()=>setHover(true)} onMouseLeave={()=>setHover(false)}>
    <div className='h-auto rounded-top p-4'>
      <header style={{fontSize:'2rem'}}><FontAwesomeIcon icon={faMoneyCheckDollar}/></header>
      <div className='pt-3 pb-3 d-flex flex-column'>
        <div className='fw-bolder' style={{fontSize:'3rem',lineHeight:'1'}}>
          $ {hover?balance.toLocaleString():fmt(balance)}
        </div>
        <div className='pt-2 fw-bold' style={{fontSize:'1.15rem'}}>Total Outstanding Balance</div>
      </div>
    </div>
    <div style={{height:1,width:'auto',margin:'0 50% 0 5%',background:'rgba(255,255,255,.5)'}}/>
    <footer className='h-auto rounded-bottom pt-3 pb-2 px-4'>
      <div className='d-flex align-items-center'>
        <div className='fs-1 fw-bold'>$ {hover?ytd.toLocaleString():fmt(ytd)}</div>
        <div className='text-body-secondary fw-bold ms-2'>YTD Sales</div>
      </div>
    </footer>
  </div>)
}



export { TotalBalanceCard }